import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

const statusFilter = {
  0: 'Ativa',
  1: 'Inativa 1',
  2: 'Inativa 2',
  3: 'Inativa 3',
  4: 'Inativa 4',
  5: 'Inativa 5',
  6: 'Inativa 6'
};

const levelFilter = {
  Semente: 'Semente',
  Bronze: 'Bronze'
};

class TableActivitySB extends React.Component {
  statusFormatter = cell => {
    return statusFilter[cell];
  };

  levelFormatter = cell => {
    return levelFilter[cell];
  };

  createCustomToolBar = props => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
          justifyContent: 'space-between'
        }}
      >
        <div style={{ width: '50%', marginLeft: '15px', height: '100%' }}>
          {props.components.searchPanel}
        </div>
        <div style={{ marginRight: '15px', height: '100%' }}>
          {props.components.exportCSVBtn}
        </div>
      </div>
    );
  };

  render() {
    const { type, indicatorsDetails } = this.props;

    const options = {
      toolBar: this.createCustomToolBar,
      exportCSVText: 'Exportar para Excel',
      noAutoBOM: false,
      noDataText: (
        <FormattedMessage
          id="table.empty"
          defaultMessage="Não há registros encontrados"
          description="Não há registros encontrados"
        />
      )
    };
    return (
      <div style={{ marginTop: '40px' }}>
        {indicatorsDetails && indicatorsDetails.length > 0 && (
          <BootstrapTable
            tableContainerClass="indicators-table-container-class"
            headerContainerClass="indicators-table-header-container-class"
            bodyContainerClass="indicators-table-body-container-class"
            data={indicatorsDetails}
            pagination
            striped
            hover
            search
            exportCSV
            csvFileName={`Relatório de ${type}.csv`}
            options={options}
            searchPlaceholder="Buscar por código ou nome"
          >
            <TableHeaderColumn
              dataField="cnCode"
              width="20%"
              dataSort={true}
              csvHeader={'Código da Consultora'}
              isKey
            >
              <FormattedMessage
                id="indicators.panel.details.cn.code"
                defaultMessage="Código da Consultora"
                description="Código da Consultora"
              />
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="cnName"
              width="30%"
              dataSort={true}
              csvHeader={'Nome da Consultora'}
            >
              <FormattedMessage
                id="indicators.panel.details.cn.name"
                defaultMessage="Nome da Consultora"
                description="Nome da Consultora"
              />
            </TableHeaderColumn>
            <TableHeaderColumn
              width="20%"
              dataField="situation"
              csvHeader={'Status da Consultora'}
              csvFormat={this.statusFormatter}
              dataFormat={this.statusFormatter}
              formatExtraData={statusFilter}
              filter={{
                type: 'SelectFilter',
                options: statusFilter,
                placeholder: 'Todos'
              }}
              dataSort={true}
            >
              <FormattedMessage
                id="indicators.panel.details.cn.status"
                defaultMessage="Status da Consultora"
                description="Status da Consultora"
              />
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="initialGpLevelDescription"
              width="15%"
              csvHeader={'Nivel início'}
              csvFormat={this.levelFormatter}
              filterFormatted
              dataFormat={this.levelFormatter}
              formatExtraData={levelFilter}
              filter={{
                type: 'SelectFilter',
                options: levelFilter,
                placeholder: 'Todos'
              }}
              dataSort={true}
            >
              <FormattedMessage
                id="indicators.panel.details.initial.gp.level.description"
                defaultMessage="Nivel início"
                description="Nivel início"
              />
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="gpLevelDescription"
              width="15%"
              dataSort={true}
              csvHeader={'Nivel atual'}
            >
              <FormattedMessage
                id="indicators.panel.details.gp.level.description"
                defaultMessage="Nivel atual"
                description="Nivel atual"
              />
            </TableHeaderColumn>
          </BootstrapTable>
        )}
      </div>
    );
  }
}

TableActivitySB.propTypes = {
  indicatorsDetails: PropTypes.array,
  type: PropTypes.string
};

export default TableActivitySB;
